// extracted by mini-css-extract-plugin
export default {"container":"IllustrationWithProgress_container__P-6gi","path":"IllustrationWithProgress_path__fZz8C"};